import CsvImportOption from '@/types/CsvImportOption.interface'
import CsvImportReport from '@/types/CsvImportReport.interface'
import { store } from '../store'
export default {
    toMappedObject(props: CsvImportOption[]): object {
        const bound = {}
        props.forEach(prop => {
            bound[prop.sdkField.field] = prop.csvField
        })
        return bound
    },
    toArray(file: File): Promise<Array<any>> {
        return new Promise((resolve, reject) => {
            window.csvparser.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => resolve(results.data)
            })
        })
    },
    exportCsv(filename: string, exportData: object): Promise<boolean> {
        /**
         * exportCsv() - Accepts a list of objects.  Creates headers from the first object in the list.
         * @param array exportData -  Array of flattened json objects, the export data
         * @var string csv Holds the .csv string data that will be exported
         * @return promise as boolean
         *
         */

        //  Convert the input to a csv string
        const csv = window.csvparser.unparse(JSON.stringify(exportData))

        //  Return an promise with a boolean response
        return new Promise((resolve, reject) => {

            var blob = new Blob([csv], { type: 'text/csv' })

            if ((navigator as any).msSaveOrOpenBlob) {
                // MS Edge and Explorer
                (navigator as any).msSaveOrOpenBlob(blob, filename)
            } else {
                var url = URL.createObjectURL(blob)
                //var link = document.getElementById('export')
                var link = document.createElement('a');
                link.setAttribute('href', url)
                link.setAttribute('download', filename)
                link.click()
            }
            resolve(true)
        })
    },
    importShowReport(report: CsvImportReport): void {
        store.commit('importReportSet', report)

        store.dispatch('dialogOpen', {
            type: 'APP',
            title: 'Import Complete!',
            color: 'primary',
            closeable: true,
            component: 'csv-import-report'
        })

    }
}